// App version - update this when releasing new versions
export const APP_VERSION = '2.2';
